<div class="fpx-form-control">
    <fpx-label *ngIf="label" [control]="formControl" [label]="label"></fpx-label>
    <div class="fpx-field-content" [ngClass]="ngTemplateName">
        <ng-container *ngIf="selectableList$ | async as selectableDataList">
            {{ setDataList(selectableDataList) }}
            <ul [ngClass]="direction" class="fpx-check-box-group"
                [ngClass]="{'input-available': formControl.value }">
                <ng-container *ngFor="let selectedData of selectableDataList">
                    <li>
                        <mat-checkbox [ngModel]="formControl.value && formControl.value.indexOf(selectedData.id)>=0"
                            (ngModelChange)="update($event,selectedData.id,selectedData.text)">
                            {{selectedData.text}}
                        </mat-checkbox>
                    </li>
                </ng-container>
            </ul>
        </ng-container>
    </div>
    <mat-error *ngIf="formControl && formControl.invalid && formControl.touched">
        {{ errorCode }}
    </mat-error>
</div>